<template>
  <edit-modal
    caption="Leervragen synchroniseren"
    :isActive="isActive">

    <template v-if="$attrs.sync">
      <div class="field">
        <div class="control">
          <label class="radio">
            <input type="radio" name="source" :value="true" v-model="fromDossier">
            Standaard leervragen importeren uit het dossier {{ $attrs.sync.dossier.titel }} en profiel {{
              $attrs.sync.profiel.titel }}
          </label>
        </div>

        <div v-show="fromDossier" class="field">
          <div class="control">
            <label class="checkbox">
              <input type="checkbox" v-model="ignoreProfile">
              Profiel informatie negeren (alle profiel leervragen worden geimporteerd wanneer deze checkbox
              geselecteerd is)
            </label>
          </div>
        </div>

        <hr>

        <div class="control">
          <label class="radio">
            <input type="radio" name="source" :value="false" v-model="fromDossier">
            Leervragen importeren uit een andere bundel
          </label>
        </div>
      </div>

      <div v-show="!fromDossier" class="field">
        <div class="control">
          <select-wrapper
            :value="selected"
            :options="bundles"
            @input="update"
            placeholder="Selecteer de bundel waaruit de leervragen aangevuld moeten worden">
          </select-wrapper>
          </div>
          <p class="help">Het synchroniseren werkt one-way. Bestaande leervragen in de bestemming worden aangevuld met de leervragen uit de bron die niet in de bestemming aanwezig zijn. Bestaande leervragen in de bestemming worden <strong>niet</strong> verwijderd wanneer die niet in de bron bestaan.</p>
      </div>

      <save-buttons
        @save="submit"
        @cancel="close"
        saveCaption="Selecteren">
      </save-buttons>
    </template>
  </edit-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import EditModal from '@/components/modules/EditModal'
import SaveButtons from '@/components/modules/SaveButtons'
import SelectWrapper from '@/components/wrappers/SelectWrapper'

export default {
  props: [
    'isActive'
  ],
  components: {
    EditModal,
    SaveButtons,
    SelectWrapper
  },
  data () {
    return {
      fromDossier: true,
      selected: null,
      ignoreProfile: false
    }
  },
  computed: {
    ...mapGetters({
      account: 'account/account'
    }),
    bundles () {
      if (this.account.bundles) {
        return this.account.bundles.map((bundle) => {
          return {
            label: bundle.name,
            value: bundle.id
          }
        })
      }

      return []
    }
  },
  methods: {
    update (payload) {
      this.selected = payload
    },
    submit () {
      this.$emit('submit', { from: this.selected, ignoreProfile: this.ignoreProfile })
      this.close()
    },
    close () {
      this.selected = null
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.modal-content {
  min-height: 25%;
}

.box {
  height: 100%;
}
</style>
